import React from 'react'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, DRIP_CLIENT_ID } from 'constants/ResourcesConstants'
import { DRIP_HELPDOC_URL } from 'constants/HelpDocConstants'

const DripPayload = {
  client_id: DRIP_CLIENT_ID,
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/drip`
}
const DripAuthUrl = 'https://www.getdrip.com/oauth/authorize'

const Drip = ({ isConnected }) => (
  <div>
    <p>With Drift and Drip, you can see all of your data and events in both places.
      For example, inside of Drift, you’ll be able to see who’s subscribed to your
      Drip campaigns, opened your emails, and more.
    </p>
    <p>Inside of Drip, you’ll be able to see things like which of your email
      subscribers have had conversations with you via Drift.</p>
    <p>Want more information? <a href={DRIP_HELPDOC_URL} target="_blank">Learn More.</a></p>

    {!isConnected &&
      <div className="connect-container">
        <IntegrationConnector
          integrationId="drip"
          isOauth={true}
          oauthLink={DripAuthUrl}
          oauthQueryParams={DripPayload}
          title="Connect Account"
          connectorType="button"
          buttonType="primary"
          className="drip-integration-connector"/>

      </div>
    }
  </div>
)

export default Drip



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Drip.js